import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (id) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'MOLD_UNQUALIFIED_PUT',
    method: 'PUT',
  });
  useEffect(() => {
    if (id) {
      exec({ url: `/api/maintain/moldunqualified`, data: id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return [isRequestSuccessed, exec];
});
